import {Axios} from '../axios/axios'
//区域列表
export const getWageList = (e) => {
  return Axios({
    url:"/adminapi/getWageList",
    method:'POST',
    data:e
  })
}
//司机下拉 adminapi/getDriverDropList
export const getDriverDropList = (e) => {
  return Axios({
    url:"/adminapi/getDriverDropList",
    method:'POST',
    data:e
  })
}
//更新司机工资 adminapi/updateWage
export const updateWage = (e) => {
  return Axios({
    url:"/adminapi/updateWage",
    method:'POST',
    data:e
  })
}
//添加备注 adminapi/updateNote
export const updateNote = (e) => {
  return Axios({
    url:"/adminapi/updateNote",
    method:'POST',
    data:e
  })
}
// 工资推送 adminapi/updateUploadStatus

export const updateUploadStatus = (e) => {
  return Axios({
    url:"/adminapi/updateUploadStatus",
    method:'POST',
    data:e
  })
}
// 工资列表 adminapi/getBusinessList
export const getBusinessList = (e) => {
  return Axios({
    url:"/adminapi/getBusinessList",
    method:'POST',
    data:e
  })
}
//工资导出 adminapi/exportBusinessList
export const exportBusinessList = (e) => {
  return Axios({
    url:"/adminapi/exportBusinessList",
    method:'POST',
    data:e
  })
}
